import React from 'react'
import './style.scss'
import aiEngine from './img/ai-engine.png'
import enableVideo from './img/enable-video.png'
import facilate from './img/facilitate.png'
import mobileFreindly from './img/mobile-friendly.png'
import provideFeedback from './img/provide-feedback.png'
import recongation from './img/recognition.png'
import trackMentor from './img/track-mentor.png'



export default function MentorShipPlatformMobile(props) {
    const keyData=props.data
    return (
        <div className='menttorship-platform-mobile'>
            <section
                id="unique-mobile"
            >
                <div className="w-100 pt-50 pb-50 position-relative">
                    <div className="container"><div className="row">
                        <div className="sec-title text-center w-100 position-relative">
                            <h2 className="mb-0">Key Functions of MAARG Program </h2>
                        </div>
                    </div>
                    </div>
                    <div className="container">
                        <div className="row">

                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={aiEngine}
                                    /><br />
                                    <p>{keyData[0]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={trackMentor}
                                    /><br />
                                    <p>{keyData[1]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={enableVideo}
                                    /> <br />
                                    <p>{keyData[2]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={mobileFreindly}
                                    /><br />
                                    <p>{keyData[3]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={recongation}
                                    /><br />
                                    <p>{keyData[4]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={facilate}
                                    /><br />
                                    <p>{keyData[5]}</p>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 col-lg-2">
                                <div className="unique-sec">
                                    <img
                                        src={provideFeedback}
                                    /><br />
                                    <p>{keyData[6]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section></div>
    )
}
